<template>
    <div class="formItem vue-dropzone"
         ref="dropZoneElement"
         v-bind:class="{ 'dz-max-files-reached' : localValue.length, 'formError' : error}">
        <label>{{ label }}
            <span v-if="subLabel"> ({{ subLabel }})</span>
        </label>
        <span v-if="localValue.length === 0 && isDisabled === true">
            Keine Daten vorhanden
        </span>
        <div class="img-wrap dropzone dropzone-previews">
            <div class="img icon-search" v-if="localValue.length > 0" @click="showGallery(localValue[0])">
                <img :src="getImageUrl(localValue[0])"/>
                <span>
            <button class="btn-icon-only icon-trash-small"
                    v-if="!readonly && !loading"
                    @click.stop.prevent="removeImage(localValue[0])"></button>

            <v-text-field
                    solo
                    flat
                    hide-details
                    class="sr-input"
                    @click.stop
                    :label="label"
                    :value="getImageTitle(localValue[0])"
                    @input="setImageTitle(localValue[0], $event)"
                    :disabled="loading || readonly"
                    :readonly="loading || readonly"
            ></v-text-field>
          </span>
            </div>
        </div>
        <div class="droparea dz-clickable" v-show="!localValue.length" v-if="!readonly">
            <i class="icon-plus"></i>
            Bild hier ablegen
            <v-progress-circular v-if="isUploading === true"
                                 :size="16"
                                 :width="2"
                                 color="#2ED1DF"
                                 indeterminate></v-progress-circular>
        </div>
    </div>
</template>

<script>
  import Dropzone from 'dropzone'
  import Vue from 'vue'

  Dropzone.autoDiscover = false
  export default {
    props: {
      error: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      label: {
        type: String
      },
      subLabel: {
        type: String,
        default: ''
      },
      value: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        isUploading: false,
        dropzone: null,
        dropzoneSettings: {
          uploadMultiple: false,
          maxFiles: 1,
          acceptedFiles: 'image/*',
          parallelUploads: 1
        }
      }
    },
    mounted () {
      if (this.readonly) {
        return
      }
      this.dropzone = new Dropzone(this.$refs.dropZoneElement, this.getDropZoneSettings)
      this.dropzone.on('addedfile', (file) => {
        this.isUploading = true
      }).on('complete', (file) => {
        this.isUploading = false
        if (typeof file.xhr !== 'undefined' && typeof file.xhr.response !== 'undefined') {
          let r = JSON.parse(file.xhr.response)
          if (r.status === 'ok') {
            this.localValue.splice(0, 1)
            for (let i = 0; i < r.tmpFiles.length; i++) {
              this.localValue.push({
                hash: r.tmpFiles[i],
                uuid: file.upload.uuid,
                title: file.name
              })
            }
          }
        }
        this.valueChanged()
      }).on('success', (file) => {
      }).on('removedfile', () => {
        this.localValue.splice(0, 1)
      }).on('error', (file) => {
        if (!file.accepted) {
          this.dropzone.removeFile(file)
        }
      })
    },
    beforeDestroy () {
      if (this.dropzone) {
        this.dropzone.destroy()
      }
    },
    methods: {
      showGallery (image) {
        this.$dialog.gallery({
          images: this.localValue,
          activeImage: image,
          dropzoneFiles: this.dropzone.files
        })
      },
      valueChanged () {
        this.$emit('input', this.localValue)
      },
      removeImage (index) {
        this.localValue.splice(0, 1)
        this.valueChanged()
      },
      getImageUrl (image) {
        if (image.url) {
          return image.url
        }
        if (this.dropzone && this.dropzone.files && image.uuid) {
          let obj = this.dropzone.files.find(obj => obj.upload.uuid === image.uuid)

          return obj.dataURL
        }

        return ''
      },
      getImageTitle (image) {
        if (typeof image.title !== 'undefined' && image.title) {
          return image.title
        }
        if (this.dropzone && this.dropzone.files && image.uuid) {
          let obj = this.dropzone.files.find(obj => obj.upload.uuid === image.uuid)
          if (typeof obj !== 'undefined') {
            return typeof obj.title !== 'undefined' ? obj.title : obj.name
          }
        }
        return ''
      },
      setImageTitle (image, value) {
        if (typeof image.title !== 'undefined') {
          return Vue.set(image, 'title', value)
        }

        if (this.dropzone && this.dropzone.files && image.uuid) {
          let obj = this.dropzone.files.find(obj => obj.upload.uuid === image.uuid)
          if (typeof obj !== 'undefined') {
            obj.title = value
          }
        }
      }
    },
    computed: {
      isDisabled () {
        return this.readonly === true || this.disabled === true || this.loading === true
      },
      localValue: {
        get () {
          return this.value || []
        },
        set (value) {
          this.$emit('input', value)
        }
      },
      getDropZoneSettings () {
        let settings = this.dropzoneSettings
        settings.url = process.env.VUE_APP_API_ENDPOINT + 'file/upload'
        settings.headers = { 'X-Session-Id': this.$store.getters['auth/getSessionId'] }
        settings.clickable = [this.$el.querySelector('.droparea')]
        settings.previewsContainer = false // this.$el.querySelector('.img-wrap')
        return settings
      }
    }
  }
</script>
